// Generated by scripts/sync-social-links.mjs; edit shared/social-links.ts.
/** Canoniek contract. Lokale API-kopieën via scripts/sync-social-links.mjs; geen out-of-root runtime-imports. */
export const KLEDA_SOCIAL = {
  instagram: 'https://www.instagram.com/kleda.nl/',
  facebook: 'https://www.facebook.com/979005828619304',
  image: 'https://cinco-media.com/assets/kleda/paul-van-der-wal-fotografie-cinco-cleaning85-fb903d05-mail.jpg',
  imageAlt: 'Een vloerkleed onder het zeepschuim in onze wasserij',
} as const;

export const SOCIAL_SOURCES = ['client-card', 's09', 's10'] as const;
export const SOCIAL_PLATFORMS = ['instagram', 'facebook'] as const;
export type SocialSource = typeof SOCIAL_SOURCES[number];
export type SocialPlatform = typeof SOCIAL_PLATFORMS[number];

export function socialLink(platform: SocialPlatform, source?: SocialSource): string {
  return source
    ? `https://client.kleda.nl/api/social-click?source=${source}&platform=${platform}`
    : KLEDA_SOCIAL[platform];
}
